import { globalAction, messageAction, callAction } from '../action';
const iframeEventPush = ( userState, eventName ) =>{
  try{
    let callInfo = userState.extraData || userState.callInfo || {};
    let agentInfo={}
    if( callInfo.call1 && callInfo.call1.userId == userState.UserId ){
      agentInfo = callInfo.call1;
    } else if( callInfo.call2 && callInfo.call2.userId == userState.UserId ){
      agentInfo = callInfo.call2;
    } else if( callInfo.calls && callInfo.calls.length ){
      for (let data of callInfo.calls) {
        if( data.userId == userState.UserId  ) {
          agentInfo = data;
          break;
        }
      }
    }
    let customerInfo = {};
    if( callInfo.call1 && callInfo.call1.isCustomer ){
      customerInfo = callInfo.call1;
    } else if( callInfo.call2 && callInfo.call2.isCustomer ){
      customerInfo = callInfo.call2;
    } else if( callInfo.calls  ){
      for (let data of callInfo.calls) {
        if( data.isCustomer  ) {
          customerInfo = data;
          break;
        }
      }
    }
    let userInfo = {
      userFullName: (callInfo.user)?callInfo.user.name:"",
      agentExtension: agentInfo.type
    }
    let disposeProcessData={
      // disposeName:callTagList.label || '',
    }
    let eventInfo = {
      type:'disposeProcess',
    }
    // window.parent.postMessage({
    //   disposeProcessData: disposeProcessData,
    //   callInfo :  callInfo,
    //   customerInfo : customerInfo,
    //   userInfo : userInfo,
    //   agentInfo : agentInfo,
    //   eventInfo : eventInfo
    // }, '*');
    const direction = callInfo.callType == "inboundCall"? "inbound":"outbound";
    let from = {
          "number": "",
          "name": ""
        },
        to = {
          "name": "",
          "number": ""
        };
    if( direction == "inbound" ){
      from.number = customerInfo.number || "";
      from.name = "";
      to.number = customerInfo.callerId || "";
      to.name = userInfo.userFullName || "";
    } else {
      from.number = customerInfo.callerId || "";
      from.name = "";
      to.number = customerInfo.number || "";
      to.name = userInfo.userFullName || "";
    }
    // "softphoneCallEnded"
    iframeEvent(eventName,{
      "direction": callInfo.callType == "inboundCall"? "inbound":"outbound",
      "answerTime": new Date(),
      "endTime": new Date(),
      "from": from,
      "to": to,
      "queue": {
          "name": callInfo.team && callInfo.team.name ? callInfo.team.name : "",
          "number": customerInfo.callerId || "",
      },
      "campaign": {
          "slug": callInfo.campaign && callInfo.campaign.name ? callInfo.campaign.name : ""
      },
      "agent": {
          "name": userInfo.userFullName || "",
          "extension": userInfo.agentExtension || ""
      },
      "hangupCause": "",
      "callId": customerInfo.callerId || ""
    })
  }catch(error){
    console.log(`iframeEvent iframeEventPush error---`,error);
  }
}
const iframeEvent = (eventName,payload) => {
  window.parent.postMessage({
    eventName,
    payload
  }, '*');
}
const sendTranscript = ( callInfo ) => {
  let transcript = callInfo.transcription || [];
  let customerInfo = {};
  if( callInfo.call1 && callInfo.call1.isCustomer ){
    customerInfo = callInfo.call1;
  } else if( callInfo.call2 && callInfo.call2.isCustomer ){
    customerInfo = callInfo.call2;
  } else if( callInfo.calls  ){
    for (let data of callInfo.calls) {
      if( data.isCustomer  ) {
        customerInfo = data;
        break;
      }
    }
  }
  sendTranscriptToSf(customerInfo.number, transcript);
}

const sendTranscriptToSf = ( phoneNumer, transcript ) => {
  try {
    const transcriptData = transcript.map(el=> {
      el = el || {}
      const from = el.from == "flow" ? "bot" : (el.from||"");
      return `${from} : ${el.content && el.content.text ? el.content.text : ""}`
    })
    iframeEvent("chatTranscript",{
      phoneNumber : phoneNumer,
      messages : transcriptData,
      timestamp : parseInt(new Date()/1000),
    })
  } catch(error){
    console.log(`iframeEvent sendTranscript error---`,error);
  }
}

const setCallBackAndDnc = ( dispatch, getState, finalTag, callBackDate, dncType, callTagFinalTag ) =>{

  const {
    customerNumber,
    customerName
  } = getState().callStateReducer;

  const {
    currentUser,
    callTeam,
    custInfo,
    callComment,
  } = getState().globalStateReducer;

  // call back set 
  if( finalTag.isCallback && callBackDate ){
    try {
      let cbDate = callBackDate.format("YYYY-MM-DD HH:mm:00")
      let data = {
        "task" : "a",
        "customerNo" : customerNumber,
        "customerName" : customerName,
        "assignTo" :  "user",
        "assignToId" : currentUser && currentUser.userId ? currentUser.userId : "",
        "dateTime" : cbDate,
        "subjectCallDetail" : `Your Callback Has been schedule at ` + callBackDate.format('LT'),
        "note" : callComment,
        "detail":{
          team : callTeam || {},
          custInfo : custInfo,
        }
      }
      dispatch(messageAction.configProcessor("callback:scedule", data));
    } catch (error) {
      console.log("Callback set error", error);
    }
  }
  // dnc set 
  if( finalTag.isDnc ){
    dncType = dncType || "team";
    let data = {
      phone_number : customerNumber,
      customerName : customerName,
      type : dncType,
      team : dncType == "team" ?  callTeam && callTeam.id ? callTeam.id : "" : "",
      tags : callTagFinalTag,
      "note" : callComment,
      campaign : dncType == "campaign" ? "":"",
    }
    dispatch(messageAction.configProcessor("dnc:add", data));
  }
}

const disposeProcess = ( tagList, callTagFinalTag, isAutoDispose = false ) =>{
  let finalTag = {};
  if( callTagFinalTag && callTagFinalTag._id ){
    finalTag = callTagFinalTag;
  } else {
    let parent = "",
      currentLevel = 0;
      tagList = tagList || [];
    for (const dispose of tagList) {
      if( dispose.name ){
        finalTag[`level${currentLevel}`] = {
          "name" : dispose.name,
          "_id":dispose._id
        }
        finalTag["parent"] = parent;
        finalTag["finalLevel"] = currentLevel;
        finalTag["label"]  = dispose.name;
        finalTag["name"]  = dispose.name;
        finalTag["_id"]  = dispose._id;
        finalTag["value"]  = dispose._id;
        finalTag["isCallback"] = dispose.isCallback || false;
        finalTag["isDnc"] =  dispose.isDnc || false;
        finalTag["level"] =  currentLevel;
        currentLevel++;
        parent = dispose._id;
      }
    }
  }
  try {
    finalTag["isAutoDispose"] = isAutoDispose;
  } catch (err) {
    console.log("Problem sending autodispose");
  }
  return { finalTag };
}
export default {
  autoDispose(dispatch, getState, teamInfo){
    let { info } = getState().callStateReducer;
    let {
      cbNotify,
      isPreviewDial,
      custInfo,
      state,
      callTagList,
      callTagFinalTag,
      callComment,
      callBackDate,
      dncType
    } = getState().globalStateReducer;
    // check call info
      let callInfo = info || {}
      let userState = state || {}
    let disposeTags = teamInfo && teamInfo.disposeTags ? teamInfo.disposeTags :  [];
    let { finalTag } = disposeProcess(disposeTags, callTagFinalTag, true );
    
    // info define 
      let extraInfo = {
        selected : finalTag, 
        tags : [finalTag], 
        finalTag : [finalTag], 
        customerInfo : custInfo.info || {}, 
        comment : callComment, 
        isCallback : false, 
        isDnc : false, 
        callBackDate : callBackDate, 
        dncType : dncType, 
      };
    // check csat 
    let csat = false;
    try {
      if( teamInfo.csatFlowId ){
        if( teamInfo.csat == true ||  teamInfo.csat == "TRUE" ){
          csat = true;
        }
      }
    } catch (error) {
      
    }

    if( callInfo.isTransferInitialed || csat ) {
      dispatch(callAction.process('AddTAGToCall', {
        sessionId: callInfo.sessionId,
        callId: callInfo.agentId,
        callId2: callInfo.custId,
        isCSAT : csat,
        ...extraInfo
      }));
      extraInfo = {};
    }
    let nextState = cbNotify ? "callback" : isPreviewDial ? "preview" : "online";
    iframeEventPush(userState,"softphoneCallEnded")
    setCallBackAndDnc( dispatch, getState, finalTag, callBackDate, dncType, finalTag )
    this.finalDispose(
      dispatch,
      getState,
      nextState,
      callInfo,
      extraInfo
    );
  },
  finalDispose(
    dispatch,
    getState,
    nextState,
    callInfo,
    extraInfo
  ){
    let message = {
      type: 'stateHandler',
      state: nextState,
      sessionId: callInfo.sessionId,
      mSessionID: callInfo.sessionId,
      initdate: callInfo.initdate,
      addTag : true, 
      subState: '',
      stateInfo: '',
      ...extraInfo
    };
    dispatch(messageAction.tagProcess('message-processor',message));
    
    dispatch(globalAction.dynamicUpdate({ key: 'callTagList', value: [] }));
    dispatch(globalAction.dynamicUpdate({ key: 'callTagFinalTag', value: {} }));
    dispatch(globalAction.dynamicUpdate({ key: 'callComment', value: "" }));
    dispatch(globalAction.dynamicUpdate({ key: 'callBackDate', value: "" }));
    dispatch(globalAction.dynamicUpdate({ key: 'dncType', value: "" }));
  },
  getTeam( getState, extraData ){
    const { teamList } = getState().profileStateReducer;
    let teamId = "",
    team   = {};
    if( extraData && extraData.team && extraData.team.id ){
      teamId = extraData.team.id;
      let teams = teamList.filter((el)=>{ return el._id == teamId})
      if( teams && teams[0] ){
        team =  teams[0];
      }
    }
    return {
      teamId,
      team
    }
  },
  autoDisposeStart( dispatch, getState, team ){
    let timeOut = parseInt(team.disposeTimeout) || 10;
    global.__disposeTime = timeOut;
    try {
      global.__currentTeamDisposeTime = timeOut;
    } catch (err) {
      console.log("Unable to set snooze timeout");
    }
    dispatch(globalAction.dynamicUpdate({ data  : {"key":"disposeTimer",value : timeOut} }));
    global.__disposeTimer = setInterval(()=>{
      global.__disposeTime--;
      if( global.__disposeTime <= 0 ){
        clearInterval(global.__disposeTimer);
        try {
          this.autoDispose(dispatch, getState, team)
        } catch (error) {
          console.log("MessageHelper.autoDispose", error);
        }
      } else {
        dispatch(globalAction.dynamicUpdate({ data  : {"key":"disposeTimer",value : global.__disposeTime} }));
      }
    },1000)
  },
  agentConnecting(dispatch, getState, data){
    try { clearTimeout(global.__callBtn); } catch (error) { console.log("clearTimeout errro"); }
    dispatch(globalAction.dynamicUpdate({ data  : {"key":"callHandlingLoader",value : false } }));
    let isOffer = false;
    try {
      let extraData =  data.data.extraData || {};
      if( extraData.call1 && extraData.call1.callerId  ){
        dispatch(globalAction.dynamicUpdate({ data  : {"key":"callerId", value : extraData.call1.callerId } }));
      }
      if( extraData.team && extraData.team.id ){
        dispatch(globalAction.dynamicUpdate({ data  : {"key":"callTeam", value : extraData.team } }));
      }

      // incomming call answer
      if( data.data.extraData.callType ==  "inboundCall" ){
        console.log("[autoAnswer] Wait for inbound call answer");
        const { currentUser } = getState().globalStateReducer;
        if( currentUser && currentUser.phoneType == "web" ) {
          try {
            let tInfo =  data.data.extraData || {};
            let { team, teamId } = this.getTeam( getState, tInfo );
            if( team.inboundOffer ){
              isOffer = true;
              this.musicPlay( "sound/full-ring.mp3", "mp3", false );
              iframeEvent("softphoneCallInvited",{
                "from" : {
                  "number": tInfo.call1 && tInfo.call1.from ? tInfo.call1.from : "",
                }
              });
            }
          } catch (error) {
            console.log("[answerCall] error", error);
          }
          if( !isOffer ){
            dispatch(messageAction.answerCall());
          }
          dispatch(globalAction.dynamicUpdate({ data  : {"key":"isOffer",value : isOffer} }));
        } else {
          dispatch(globalAction.dynamicUpdate({ data  : {"key":"isOffer",value : false} }));
        }
      }
    } catch (error) {
      
    }
    try {
      let extraData =  data.data.extraData;
      if( extraData.callType ==  "inboundCall" || extraData.callType =="Progressive" || extraData.isTransfer ) {
        try{  
          // document.getElementById('notificationMedia').play();
          if( !isOffer ){
            this.musicPlay( "sound/ring-file.wav", "wav", false )
          }
          // window.parent.postMessage({callInfo: extraData}, '*');
          // iframeEventPush(extraData);
        } catch(e){
        }
      }
    } catch (error) {
      console.log("notificationMedia play error",);
    }
  },
  checkForceDispose(dispatch, getState, data){
    let extraData =  data && data.data && data.data.extraData ? data.data.extraData : {};
    const {
      teamId,
      team
    } = this.getTeam( getState, extraData );
    let LastState = data.data.LastState;
    if( extraData.callType ==  "inboundCall" && team.inboundOffer && ( LastState == "AGENT_CONNECTING" || LastState == "AGENT_RINING")){
      return true;
    }
    return false;
  },
  agentOfferDispose(dispatch, getState, data){
    let extraData =  data && data.data && data.data.extraData ? data.data.extraData : {};
    let { info } = getState().callStateReducer;
    let callInfo = info || {}
    const {
      teamId,
      team
    } = this.getTeam( getState, extraData );
    let nextState = team.afterOfferState || "break";
    let subState = "";
    let stateInfo = "";
    if( nextState ==  "break" ){
      if( team.breakLists && team.breakLists[0] ){
        stateInfo = {
          id : team.breakLists[0]._id || "",
          name : team.breakLists[0].name || ""
        }
      }
    }
    let finalTag = {
      "parent" : "",
      "finalLevel" : 0,
      "label" : "OFFER REJECT",
      "name" : "OFFER REJECT",
      "_id" : "27aefb4c-022d-4640-af28-8c5900becb5b",
      "value" : "27aefb4c-022d-4640-af28-8c5900becb5b",
      "isCallback" : false,
      "isDnc" : false,
      "level" : 0,
    };

    // info define 
    let extraInfo = {
      selected : finalTag,
      tags : [finalTag],
      finalTag : [finalTag],
      customerInfo : {},
      comment : "",
      isCallback : false,
      isDnc : false,
      callBackDate : "",
      dncType : false,
      subState : subState,
      stateInfo : stateInfo
    };
    this.finalDispose(
      dispatch,
      getState,
      nextState,
      callInfo,
      extraInfo
    );
  },
  musicPlay( url, type, loop ){
    // sound/ring-file.wav
    // sound/full-ring.mp3
    // musicPlay( "sound/ring-file.wav", "mp3", false )
    // musicPlay( "sound/full-ring.mp3", "mp3", false )
    try {
      const audio = document.getElementById('notificationMedia');
      if (!audio) {
        return;
      }
      if (audio.canPlayType(`audio/${type}`)) {
        audio.setAttribute('src',url);
        // audio.currentTime = 5;
        audio.play();
      }
    } catch (error) {
      console.log(`[Notification] Play Error`, error);
    }
  },
  musicPause(){
    try {
      const audio = document.getElementById('notificationMedia');
      audio.pause();
    } catch (error) {
      console.log(`[Notification] Pause Error`, error);
    }
  },
  iframeEvent,
  iframeEventPush,
  sendTranscript,
}


// WEBPACK FOOTER //
// src/store/helper/message.helper.js